import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isObject from 'lodash/fp/isObject';
import Checkbox from '../checkbox/Checkbox';
import RadioButton from '../radiobutton/RadioButton';
var TreeLeaf = /*#__PURE__*/React.memo(function (props) {
  var item = props.item,
    hasMultiselect = props.hasMultiselect,
    showRadioButtons = props.showRadioButtons,
    isSelected = props.isSelected,
    onSelectItem = props.onSelectItem,
    onActiveItem = props.onActiveItem;
  var treeNodeClassNames = classNames('TreeLeaf', 'form-group margin-bottom-0', isSelected && 'active', item.className && item.className);
  return /*#__PURE__*/React.createElement("div", {
    className: treeNodeClassNames,
    "data-key": item.id
  }, hasMultiselect && /*#__PURE__*/React.createElement(Checkbox, {
    className: "TreeCheckbox",
    checked: isSelected,
    onClick: onSelectItem
  }), !hasMultiselect && showRadioButtons && /*#__PURE__*/React.createElement(RadioButton, {
    className: "TreeRadioButton",
    checked: isSelected,
    onChange: onSelectItem
  }), /*#__PURE__*/React.createElement("span", {
    className: "TreeLabel",
    onClick: onActiveItem
  }, /*#__PURE__*/React.createElement("span", {
    className: "TreeLabelName"
  }, /*#__PURE__*/React.createElement("span", {
    className: "rioglyph rioglyph-".concat(item.type, " margin-top--1")
  }), /*#__PURE__*/React.createElement("span", {
    className: "TreeLabelNameText"
  }, /*#__PURE__*/React.createElement("span", {
    className: "TreeLabelNameTextHeadline"
  }, isObject(item.name) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "text-light margin-right-3"
  }, item.name.firstName), /*#__PURE__*/React.createElement("span", null, item.name.lastName)) : /*#__PURE__*/React.createElement(React.Fragment, null, item.name)), item.info && /*#__PURE__*/React.createElement("span", {
    className: "TreeLabelNameTextSubline"
  }, item.info)))));
});
TreeLeaf.displayName = 'TreeLeaf';
TreeLeaf.defaultProps = {};
TreeLeaf.propTypes = {
  item: PropTypes.object,
  hasMultiselect: PropTypes.bool,
  showRadioButtons: PropTypes.bool,
  isSelected: PropTypes.bool,
  onSelectItem: PropTypes.func,
  onActiveItem: PropTypes.func
};
export default TreeLeaf;